import styles from "./ChatGPTButton.module.css";

const ChatGPTButton = () => {
  const chatGPTUrl =
    "https://chatgpt.com/g/g-6937fb03c0e08191bab61f447c3c77c5-eau-group-ai-assistant";

  const openChatGPT = () => {
    window.open(chatGPTUrl, "_blank", "noopener,noreferrer");
  };

  return (
    <div className={styles.chatGPTContainer}>
      <button
        className={styles.botButton}
        onClick={openChatGPT}
        aria-label="Open EAU Assistant"
      >
        {/* Chat Bubble */}
        <div className={styles.chatBubble}>
          <span className={styles.eauText}>EAU</span>
        </div>

        {/* Glow Effect */}
        <div className={styles.botPulse}></div>

        <span className={styles.botTooltip}>
          <strong>EAU Assistant</strong>
          <span className={styles.tooltipSubtext}>Click to chat!</span>
        </span>
      </button>
    </div>
  );
};

export default ChatGPTButton;
